import React from "react";

export default function DiagnosticScreen({ t = {} }) {
  return (
    <div style={{ background: "#1C3A28", minHeight: "100%", paddingBottom: 32 }}>
      {/* Header */}
      <div style={{ background: "#2D5A3D", padding: "20px 20px 18px" }}>
        <div style={{ fontSize: 22, fontWeight: 900, color: "#F8F6F1", textAlign: "center" }}>
          {t.diagnostic || "Diagnostic"}
        </div>
      </div>

      <div style={{ padding: "20px 16px 0" }}>
        <div style={{
          background: "linear-gradient(135deg, #1C3A28, #0a1a10)",
          border: "1px solid rgba(45,90,61,0.5)",
          borderRadius: 18, padding: 20, textAlign: "center",
        }}>
          <div style={{ fontSize: 32, marginBottom: 10 }}>🔌</div>
          <div style={{ fontSize: 15, fontWeight: 900, color: "#9FE1CB", marginBottom: 6 }}>
            {t.diagnosticOBD2 || "Diagnostic OBD2"}
          </div>
          <div style={{ fontSize: 12, color: "#8A8A8E", marginBottom: 14, lineHeight: 1.6 }}>
            {t.obd2Desc || "Connectez un adaptateur OBD2 Bluetooth pour lire les codes d'erreur de votre camping-car et obtenir une analyse IA."}
          </div>
          <button
            disabled
            style={{
              width: "100%", padding: "13px 0", borderRadius: 14, border: "none",
              background: "rgba(159,225,203,0.15)", color: "rgba(159,225,203,0.5)",
              fontSize: 14, fontWeight: 800, cursor: "not-allowed", fontFamily: "inherit",
            }}
          >
            🔌 {t.connecterOBD2 || "Connecter un adaptateur OBD2"}
          </button>
        </div>
      </div>

      {/* Bannière bientôt disponible */}
      <div style={{ padding: "14px 16px 0" }}>
        <div style={{
          background: "#1C3A28",
          borderRadius: 14, padding: "16px 20px",
          textAlign: "center",
        }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "white", lineHeight: 1.5 }}>
            {t.diagBientotDispo || "Les fonctions diagnostic de cette page seront bientôt disponibles"}
          </div>
        </div>
      </div>

      {/* Diagnostic IA — Voyants */}
      <div style={{ padding: "14px 16px 0" }}>
        <div style={{
          background: "linear-gradient(135deg, #1C3A28, #0a1a10)",
          border: "1px solid rgba(196,98,45,0.4)",
          borderRadius: 18, padding: 20, textAlign: "center",
        }}>
          <div style={{ fontSize: 32, marginBottom: 10 }}>🔆</div>
          <div style={{ fontSize: 15, fontWeight: 900, color: "#C4622D", marginBottom: 6 }}>
            {t.diagIA_titre || "Diagnostic IA"}
          </div>
          <div style={{
            background: "rgba(196,98,45,0.06)",
            border: "1.5px dashed rgba(196,98,45,0.3)",
            borderRadius: 12, padding: "20px 16px", marginBottom: 14,
          }}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>📷</div>
            <div style={{ fontSize: 12, color: "rgba(248,246,241,0.5)", lineHeight: 1.5 }}>
              {t.diagIA_photo_label || "Photographiez vos voyants allumés"}
            </div>
          </div>

          {[
            { icon: "🔍", label: t.diagIA_feat1 || "Identification instantanée des voyants" },
            { icon: "🧠", label: t.diagIA_feat2 || "Analyse IA de la cause probable" },
            { icon: "🛠️", label: t.diagIA_feat3 || "Conseils d'urgence et marche à suivre" },
          ].map((f, i) => (
            <div key={i} style={{
              display: "flex", alignItems: "center", gap: 10,
              padding: "8px 0", textAlign: "left",
              borderTop: i > 0 ? "1px solid rgba(248,246,241,0.06)" : "none",
            }}>
              <span style={{ fontSize: 15 }}>{f.icon}</span>
              <span style={{ fontSize: 12, color: "rgba(248,246,241,0.55)" }}>{f.label}</span>
            </div>
          ))}

          <button
            disabled
            style={{
              width: "100%", padding: "13px 0", borderRadius: 14, border: "none",
              background: "rgba(196,98,45,0.15)", color: "rgba(196,98,45,0.5)",
              fontSize: 14, fontWeight: 800, cursor: "not-allowed", fontFamily: "inherit",
            }}
          >
            📷 {t.diagIA_btn || "Scanner mes voyants — Bientôt disponible"}
          </button>
        </div>
      </div>
    </div>
  );
}
